export enum DonorShieldAliasType {
    DonorShieldDirect = 1,
    Donor             = 2
}